import { Drawer, DrawerProps, styled } from '@mui/material';

export const CustomDrawer = styled(Drawer)<DrawerProps>(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '100%',
    maxWidth: '500px',
  },
}));
